export default __webpack_public_path__ + "static/footer-bg-11d244be7ad6b6659216b0a965807e74.png";